<template>
    <div class="card dashboard-card padding-20">
        <span @click="$emit('click')" class="click-handler"> 
            <i class="fa fa-chevron-right" /> 
        </span>
        <div class="h-100 w-100 d-flex align-items-center justify-content-between">
            <div :class="`dashboard-card__title text-${statusColor}`" v-html="title" />
            <div :class="`dashboard-card__icon text-${statusColor} text-right`">
                {{ count }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DashboardCard",
    props: {
        title: {
            type: String,
            default: ""
        },
        statusColor: {
            type: String,
            default: ""
        },
        count: {
            type: [Number, String],
            default: 0
        }

    }
}
</script>

<style lang="scss">
 .dashboard-card {
     position: relative;
    &.card {
        display: flex;
        flex-direction: row !important;
        justify-content: center;
        width: 100%;
        height: 150px;
        box-shadow: none !important;
        border-radius: 0 0 0 0 !important;
        border: 2px solid #ccc !important;
    }

    &__icon {
        font-weight: bolder;
        font-size: 40px;
        width: 40%;
    }

    &__title {
        border-left: 2px solid var(--execlist-color-gray);
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        font-size: 22px;
        width: fit-content;
        font-weight: bold;
        flex-wrap: wrap;
        width: 50%;
    }

    .click-handler {
        right: 10px;
        top: 5px;
        position: absolute;
        border: 2px solid #ccc;
        color: #aaa;
        height: 40px;
        width: 40px;
        min-width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        cursor: pointer;
    }

 }
</style>
